import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IntegrationInterface } from '@interface/integration/integration.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialIntegrationsState } from './integrations.initial-state';

export const integrationsSlice = createSlice({
  name: 'integrations',
  initialState: initialIntegrationsState,
  reducers: {
    ...baseReducerActions(initialIntegrationsState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<IntegrationInterface[]>>) => {
      state.data = mapifyPayload(payload?.data ?? [], 'serviceId');
    },
    setStatus: (state, { payload }: PayloadAction<{ id: string; isEnabled: boolean }>) => {
      state.data[payload.id] = {
        ...state.data[payload.id],
        isEnabled: payload.isEnabled,
      };
    },
    setIntegration: (state, { payload }: PayloadAction<ResponseDataInterface<IntegrationInterface>>) => {
      state.data[payload.data.serviceId] = payload.data;
    },
    setMap: (state, { payload }: PayloadAction<ResponseDataInterface<IntegrationInterface>>) => {
      state.data[payload.data.serviceId].remapInstructions = payload.data.remapInstructions;
    },
  },
});

export const integrationsActions = integrationsSlice.actions;
